export default __webpack_public_path__ + "static/media/FarCry5.2f0e92a6.jpg";